// extracted by mini-css-extract-plugin
var _1 = "zXUbb";
var _2 = "PgAOS";
var _3 = "vedav";
var _4 = "MHmu6";
var _5 = "yHZAO";
var _6 = "tUstV";
var _7 = "YooW7";
var _8 = "vQdbB";
var _9 = "c4xPw";
export { _1 as "close-button", _2 as "close-icon", _3 as "footer", _4 as "mobile-popup", _5 as "mobile-popup--inverse", _6 as "mobile-popup-background", _7 as "mobile-popup-background--inverse", _8 as "mobile-popup-content", _9 as "mobile-popup-content--no-close-button" }
